import { Maybe } from '../../../__generated__/globalTypes'

import { ContactFragment, isContactFragment } from './ContactFragment'

import relatedContactFragmentRawString from '../RelatedContactFragment.graphql'

export const relatedContactFragmentString = relatedContactFragmentRawString

export type RelatedContactFragment = ContactFragment & {
  homePhone: Maybe<string>
  cellPhone: Maybe<string>
  workPhone: Maybe<string>
  faxNumber: Maybe<string>
  website: string
  emailAddress: Maybe<string>
}

export const isRelatedContactFragment = (
  fragment: any,
): fragment is RelatedContactFragment =>
  (isContactFragment(fragment) as boolean) &&
  (fragment.homePhone === null || typeof fragment.homePhone === 'string') &&
  (fragment.cellPhone === null || typeof fragment.cellPhone === 'string') &&
  (fragment.workPhone === null || typeof fragment.workPhone === 'string') &&
  (fragment.faxNumber === null || typeof fragment.faxNumber === 'string') &&
  typeof fragment.website === 'string' &&
  (fragment.emailAddress === null || typeof fragment.emailAddress === 'string')
